"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailSignupDTO = exports.RegisterDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
let RegisterDTO = class RegisterDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.RegisterDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "language", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "displayMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "communicationConsent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "referral", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userAgent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoProvider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User locale'),
    __metadata("design:type", String)
], RegisterDTO.prototype, "language", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User display mode'),
    __metadata("design:type", String)
], RegisterDTO.prototype, "displayMode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User preferred display mode'),
    __metadata("design:type", String)
], RegisterDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User marketing consent'),
    __metadata("design:type", Boolean)
], RegisterDTO.prototype, "communicationConsent", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User referral, if applicable'),
    __metadata("design:type", String)
], RegisterDTO.prototype, "referral", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)("User agent of the user's browser"),
    __metadata("design:type", String)
], RegisterDTO.prototype, "userAgent", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('SSO provider used during registration'),
    __metadata("design:type", String)
], RegisterDTO.prototype, "ssoProvider", void 0);
RegisterDTO = __decorate([
    (0, decorators_1.Describe)('A user signed up')
], RegisterDTO);
exports.RegisterDTO = RegisterDTO;
let EmailSignupDTO = class EmailSignupDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.EmailSignupDTO) {
};
EmailSignupDTO = __decorate([
    (0, decorators_1.Describe)('A user signed up for email delivery')
], EmailSignupDTO);
exports.EmailSignupDTO = EmailSignupDTO;
